module.exports = __webpack_public_path__ + "static/stake-b247d0d99067083b1790045b5b283bbd.jpg";